<template>
  <svg
    :id="uniqueId"
    :class="classnames"
    :fill="`currentColor`"
    :height="getHeight"
    :viewBox="`0 0 24 24`"
    :width="getWidth"
  >
    <polygon id="Combined-Shape" points="1.99999999 0 0 1.99999999 9.99999998 12 0 21.9999999 1.99999999 24 12 14 21.9999999 24 24 21.9999999 14 12 24 1.99999999 21.9999999 0 12 9.99999998" />
  </svg>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'svg-icon-close'

  export default {
    name: 'SvgIconClose',
    mixins: [ bem ],
    props: {
      height: {
        default: '24',
        type: String
      },
      width: {
        default: '24',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      getHeight: function () {
        const height = `${this.height}px`

        return height
      },
      getWidth: function () {
        const width = `${this.width}px`

        return width
      }
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconClose.vue